import { memo, useMemo } from "react";
import { Scrollbars } from "@tecorien/mimic-v2";
import { getExcelColumnName, getExcelColumnNumber } from "../../../generic";

import styles from "./style.module.scss";

export type SpreadsheetViewProps = {
  data: (any[])[] | null,
  highlightedColumns?: { [key: string]: string },
  highlightedRows?: { [key: number]: string }
}

export const SpreadsheetView = memo<SpreadsheetViewProps>(({ data, highlightedColumns, highlightedRows }) => {

  const columnsCount = Math.max(...data?.map(x => x.length) || [], 0);

  const normalizedHighlightedColumns = useMemo(() => {
    return Object.entries(highlightedColumns || {})
      .reduce(
        (acc, val) => {
          acc.set(getExcelColumnNumber(val[0]), val[1]);
          return acc;
        },
        new Map<number, string>(),
      );
  }, [ highlightedColumns ]);

  const normalizedHighlightedRows = useMemo(() => {
    return Object.entries(highlightedRows || {})
      .reduce(
        (acc, val) => {
          acc.set(Number(val[0]), val[1]);
          return acc;
        },
        new Map<number, string>(),
      );
  }, [ highlightedRows ]);

  return (
    <Scrollbars className={styles.root}>
      <table className={styles.table}>
        <thead>
          {
            <tr>
              <th>№</th>
              {
                [ ...new Array(columnsCount) ].map((cell, cellIndex) => {
                  const highlightColor = normalizedHighlightedColumns.get(cellIndex + 1);

                  return (
                    <th key={cellIndex} style={highlightColor ? { background: highlightColor } : undefined}>
                      {`${getExcelColumnName(cellIndex + 1)}`}
                    </th>
                  );
                })
              }
            </tr>
          }
        </thead>
        <tbody>
          {
            data?.map((row, rowIndex) => {
              const highlightColor = normalizedHighlightedRows.get(rowIndex + 1);

              return (
                <tr
                  key={rowIndex}
                  style={highlightColor ? { "--rowHighlightColor": highlightColor } as any : undefined}
                  data-row-highlighted={!!highlightColor}
                >
                  <td>{rowIndex + 1}</td>
                  {
                    [ ...row, ...new Array(columnsCount) ].slice(0, columnsCount)
                      .map((cell, cellIndex) => {
                        const highlightColor = normalizedHighlightedColumns.get(cellIndex + 1);

                        return (
                          <td key={cellIndex} style={highlightColor ? { background: highlightColor } : undefined}>
                            {`${(cell instanceof Date ? (cell.toISOString()) : cell) || ""}`}
                          </td>
                        );
                      })
                  }
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </Scrollbars>
  );
});

export default SpreadsheetView;
